module.exports = __webpack_public_path__ + "static/blog_background-aa24ee02a8af721e63ee4a05a064681c.jpg";